<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="main" style="">
    <div style="position: relative">
      <div v-show="address != ''" style="font-size: 16px;">Address: {{ address }}
        <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer"
           v-clipboard:copy="address"
           v-clipboard:success="doClipboard"
           v-clipboard:error=""></i>
        <span style="margin-left: 50px;">Balance：{{ balance | roundOff(2) }} NBC</span>
      </div>
      <el-tabs v-if="this.$route.query.addr" v-model="activeName" @tab-click="changeType">
        <el-tab-pane label="All" name="all"></el-tab-pane>
        <el-tab-pane label="From" name="from"></el-tab-pane>
        <el-tab-pane label="To" name="to"></el-tab-pane>
      </el-tabs>
      <i @click="init()" class="el-icon-refresh"
         style="font-size: 22px;cursor: pointer;position: absolute;right: 0;top: 9px"></i>
    </div>
    <div style="position: relative">
      <table style="width:100%;max-width: 100%;margin-bottom: 20px;border-spacing: 0;">
        <thead>
        <tr style="border-color: #E1E1E1; border-width: 1px; background-color: #F9F9F9; border-top-style: solid;">
          <th>TxHash</th>
          <th>Block</th>
          <th>Time</th>
          <th>From</th>
          <th>To</th>
          <th>Value</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="tran in transactionList">
          <td style="width: 110px">
            <i v-show="tran.status == 0" class="el-icon-warning"
               style="color: #DB9A03;margin-right: 2px"></i>
            <a @click="changeRoute('/transactionDetail', {hash: tran.txHash}, true)">
              {{ addressSub(tran.txHash, 5) }}
            </a>
          </td>
          <td>
            <a @click="changeRoute('/blockDetail', {number: tran.blockNumber}, true)">
              {{ tran.blockNumber }}
            </a>
          </td>
          <td>
            <span>{{ tran.timestamp | time2Date }}</span>
          </td>
          <td>
            <a @click="changeRoute('/NBC',{'addr': tran.from}, true)">
              {{ tran.from }}
            </a>
          </td>
          <td>
            <a @click="changeRoute('/NBC',{'addr': tran.to}, true)">
              {{ tran.to }}
            </a>
          </td>
          <td>{{ tran.value | roundOff(2)}} NBC</td>
        </tr>
        </tbody>
      </table>
      <LoadingV></LoadingV>
      <div @click="getMore()" v-show="!isEnd && !loadingV.show"
           style="width: 100%;text-align: center;cursor: pointer">load more
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import {getNBCBalance} from '@/assets/js/etherjs/web3';
import {getAddress} from '@/assets/js/etherjs/until';
import Config from '@/assets/js/config/load';
import {ethers} from "ethers"

const config = Config();

export default {
  name: "transactionList",
  data() {
    return {
      transactionList: [],
      params: {
        pageNo: 1,
        pageSize: 20,
        addr: "",
        from: "",
        to: "",
      },
      address: "",
      label: "",
      activeName: "all",
      isEnd: false,
      balance: 0
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    '$route'(to, from) {
      if (to.name == from.name) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.transactionList = [];
      this.isEnd = false;
      this.params.from = this.$route.query.from ? getAddress(this.$route.query.from) : '';
      this.params.to = this.$route.query.to ? getAddress(this.$route.query.to) : '';
      this.params.addr = this.$route.query.addr ? getAddress(this.$route.query.addr) : '';
      this.params.contractAddress = config.NBC.address;
      this.params.pageNo = 1;
      if (this.params.to != "") this.address = this.params.to;
      if (this.params.from != "") this.address = this.params.from;
      if (this.params.addr != "") this.address = this.params.addr;
      this.getTransactionList();
    },
    getTransactionList() {
      if (this.isEnd) return;
      this.aLoadingV({show: true});
      this.getBalance();
      let params = JSON.parse(JSON.stringify(this.params));
      if (params.from || params.to) delete params.addr;
      return axios.get(this.requestConfig.apiHost + '/client/explore/erc20', {params}).then((response) => {
        this.aLoadingV({show: false});
        let list = response.data.data;
        for (let i in list) {
          list[i].value = parseFloat(ethers.utils.formatEther(list[i].value));
          console.log(list[i].value)
        }
        this.transactionList = this.transactionList.concat(list);
        if (response.data.data.length < 15) this.isEnd = true;
      }).catch((error) => {
        this.aLoadingV({show: false});
        console.log(error);
      });
    },

    getMore() {
      this.params.pageNo++;
      return this.getTransactionList();
    },

    changeType(tab, event) {
      this.isEnd = false;
      this.transactionList = [];
      this.params.pageNo = 1;

      if (tab.name == 'to') {
        this.params.to = this.$route.query.addr;
        this.params.from = '';
      }

      if (tab.name == 'from') {
        this.params.from = this.$route.query.addr;
        this.params.to = '';
      }

      if (tab.name == 'all') {
        this.params.from = '';
        this.params.to = '';
      }

      this.getTransactionList();
    },
    changeR(addr) {
      /*this.$set(this.$route.query, "addr", addr);
      // this.$route.query.addr = addr;*/
      this.$router.push({
        query: {'addr': addr}
      });

      // this.init();
    },

    doClipboard() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },

    async getBalance() {
      if (this.address)
        this.balance = await getNBCBalance(this.address);
    }
  }

}
</script>
<style lang="scss">
.main {
  width: 1200px;
  margin: 0 auto;
}

table {
  padding: 10px 0px;
}

table tr th, table tr td {
  text-align: left;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  font-size: 13px;
  border-top: 1px solid #ddd;
}

table tr td a {
  color: #3498db;
  text-decoration: none;
}

table tr td a:hover {
  text-decoration: underline;
  text-decoration-color: #3498db;
}
</style>
